import 'stylesheets/pages/premium/pricing/style';

import PriceDurationChange from 'modules/PriceDurationChange';
import PricePlanHelp from 'modules/PricePlanHelp';
import Tooltip from 'modules/Tooltip';

new PriceDurationChange();
new PricePlanHelp();
new Tooltip();
